import Admin from "./Admin/routes.js";
import Audits from "./Audits/routes.js";
import Claims from "./Claims/routes.js";
import CustomerPortal from "./CustomerPortal/routes.js";
import Database from "./Database/routes.js";
import FlightTestCrew from "./FlightTestCrew/routes.js";
import Home from "./Home/routes.js";
import Leave from "./Leave/routes.js";
import Matrices from "./Matrices/routes.js";
import OpenForms from "./OpenForms/routes.js";
import PoolCarBooking from "./PoolCarBooking/routes.js";
import Regulations from "./Regulations/routes.js";
import SafetyManagement from "./SafetyManagement/routes.js";

const all = [
    ...Home,
    ...Admin,
    ...CustomerPortal,
    ...Database,
    ...Audits,
    ...Leave,
    ...Matrices,
    ...FlightTestCrew,
    ...OpenForms,
    ...PoolCarBooking,
    ...Regulations,
    ...Claims,
    ...SafetyManagement,
];



export default all;
